import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CollapseItem } from './model/collapse.model';

@Component({
  selector: 'collapse-list',
  templateUrl: './collapse-list.component.html',
  styleUrls: ['./collapse-list.component.scss'],
  standalone: false,
})
export class CollapseListComponent {
  @Input() collapseList!: CollapseItem[];
  @Input() isHtmlEditable = false;
  @Output() _onOpenItem = new EventEmitter<any>();
  @Output() _onCloseItem = new EventEmitter<any>();

  handlerOnOpenItem(event: any) {
    this._onOpenItem.emit(event);
  }

  handlerOnCloseItem(event: any) {
    this._onCloseItem.emit(event);
  }
}
